import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { AuthService } from '../reducers/auth/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  template: ``,
})
export class LogoutComponent implements OnInit {
  private authService = inject(AuthService);
  private cookieService = inject(CookieService);

  async ngOnInit() {
    // `AuthService.logout()` awaits the API call and the Customer.io reset, so
    // the reload can happen straight after — no timer to race it.
    await this.authService.logout();
    this.cookieService.delete('hubspotChatVisible', '/');

    // Required. `CLEAR_SESSION` only resets the ngrx store; root-provided services and
    // signal stores keep the session's data until the page is torn down. This reload is
    // what drops them, so the next user on this browser cannot see the previous one's.
    window.location.reload();
  }
}
